import { jsx as _jsx } from "react/jsx-runtime";
import Message from "@arco-design/web-react/es/Message";
import { NewBaseIcon } from "../NewBaseIcon";
import styles from "./index.module.scss";
import classNames from "classnames";
import { info_fill, warning_fill, error_fill, success_fill, close } from "@/assets/icons/svgV2";
class ToastV2 {
  static success(content, duration, onClose) {
    let closable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return ToastV2.toast("success", content, duration, closable, onClose);
  }
  static error(content, duration, onClose) {
    let closable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return ToastV2.toast("error", content, duration, closable, onClose);
  }
  static warning(content, duration, onClose) {
    let closable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return ToastV2.toast("warning", content, duration, closable, onClose);
  }
  static info(content, duration, onClose) {
    let closable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return ToastV2.toast("info", content, duration, closable, onClose);
  }
  static toast(type, content) {
    let duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2000,
      closable = arguments.length > 3 ? arguments[3] : void 0,
      onClose = arguments.length > 4 ? arguments[4] : void 0;
    const ICON_TYPE = {
      info: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: info_fill,
        className: styles.info_icon
      }),
      warning: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: warning_fill,
        className: styles.warning_icon
      }),
      error: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: error_fill,
        className: styles.error_icon
      }),
      success: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: success_fill,
        className: styles.success_icon
      })
    };
    return Message[type]({
      content,
      duration,
      closable,
      icon: ICON_TYPE[type],
      onClose,
      closeIcon: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: close,
        className: styles.close_btn
      }),
      className: classNames(styles.custom_message)
    });
  }
}
export default ToastV2;